import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FormErrorMessageProps {
  isValid: boolean;
  submitCount: number;
  errorMessage: string | undefined;
  ff_update_form_validation?: boolean;
}

export const FormErrorMessage: React.FC<FormErrorMessageProps> = ({
  isValid,
  submitCount,
  errorMessage,
  ff_update_form_validation,
}) => {
  const { t: translate } = useTranslation("lists");

  const shouldShowError = ff_update_form_validation
    ? (submitCount > 0 && !isValid) || errorMessage
    : !isValid || errorMessage;

  if (!shouldShowError) return null;

  return (
    <Typography color="error" variant="caption">
      {!isValid
        ? translate("forms.preview.required_fields_empty")
        : errorMessage}
    </Typography>
  );
};
